/**
 * wireVisionDebug — Agent smoke hooks for FoW / wards (P3-10 / SPY-14).
 */
import { buildAramFowDebugSnapshot } from '../../domain/vision/aramFowOverlay.js';
import { wardRemainingSec } from '../../domain/vision.js';
import { attachTeamCanSeeHook } from './wireTeamVisionDebug.js';
import { attachSnapshotTeamVisionHook } from './wireSnapshotTeamVisionDebug.js';

export function wireVisionDebug({
  matchRuntime,
  getPlayer,
  getWallBoxes,
  getBushZones,
  getMapSceneState,
  getAlliedViewers
}) {
  if (typeof window === 'undefined') return;

  window.__debugPlaceWard = (type = 'sight_ward') => {
    const p = typeof getPlayer === 'function' ? getPlayer() : null;
    if (!p || !matchRuntime) return null;
    return matchRuntime.placeWard(type, p.x, p.z, p.team || 'blue');
  };

  window.__debugGetWards = () => (matchRuntime?.activeWards || []).map((w) => ({
    id: w.id,
    type: w.type,
    x: w.x,
    z: w.z,
    team: w.team,
    expiresAt: w.expiresAt,
    remainingSec: wardRemainingSec(w, matchRuntime?.gameTime || 0),
    hasTrueSight: w.hasTrueSight
  }));

  window.__debugVisionRadius = () => {
    const p = typeof getPlayer === 'function' ? getPlayer() : null;
    return p?.visionRadius ?? null;
  };

  window.__debugFowState = () => {
    const p = typeof getPlayer === 'function' ? getPlayer() : null;
    const wallBoxes = typeof getWallBoxes === 'function' ? getWallBoxes() : [];
    const sceneState = typeof getMapSceneState === 'function' ? getMapSceneState() : null;
    const extras = typeof getAlliedViewers === 'function' ? getAlliedViewers() : [];
    const snap = buildAramFowDebugSnapshot({
      viewer: p,
      wallBoxes: wallBoxes || [],
      activeWards: matchRuntime?.activeWards || [],
      team: p?.team || 'blue',
      gameTime: matchRuntime?.gameTime ?? null,
      alliedViewers: extras || []
    });
    return {
      ...snap,
      mapId: matchRuntime?.mapId || null,
      overlayActive: Boolean(sceneState?.fowClearRoot)
    };
  };

  attachTeamCanSeeHook(window, {
    getPlayer,
    getAlliedViewers,
    getWallBoxes,
    getBushZones,
    matchRuntime
  });
  attachSnapshotTeamVisionHook(window, {
    getPlayer,
    getAlliedViewers,
    getWallBoxes,
    matchRuntime
  });

  return {
    placeWard: window.__debugPlaceWard,
    getWards: window.__debugGetWards,
    fowState: window.__debugFowState,
    teamCanSee: window.__debugTeamCanSee,
    snapshotTeamVision: window.__debugSnapshotTeamVision
  };
}
